/**
 * MintlyTable's breakpoints, in a module of their own.
 *
 * SkeletonLoader has to draw the same shape the table is about to draw, so it reads these. They
 * used to live in Table/index.tsx, which was fine until the table started rendering the skeleton
 * itself (the `loading` prop): then the two modules imported each other. A leaf module breaks the
 * cycle; index.tsx re-exports both names so existing imports keep working.
 */

/**
 * Columns kept in the tablet table when the page does not choose them. Pages list their selectors
 * in order of importance, so the first three are the three highest-value ones; the rest move into
 * an expandable row detail rather than being dropped or pushed into a horizontal scroller.
 */
export const TABLET_COLUMNS = 3;

/** The tablet band, as one string. Matches `r.tablet` in styles/_responsive.scss. */
export const TABLET_QUERY = '(min-width: 768px) and (max-width: 1023px)';
